module.exports = __webpack_public_path__ + "img/line-contact-icon-white.aee39d4f.png";